import { WhatsNewActionTypes } from 'actionsConstants';

export function GET_WHATS_NEW(autoOpen: boolean = false) {
  return {
    type: WhatsNewActionTypes.GET_WHATS_NEW,
    payload: {
      autoOpen,
    },
  };
}

export function SET_WHATS_NEW(
  releases, latestMajorReleaseId, open: boolean = false, hasUnseen: boolean = false) {
  return {
    type: WhatsNewActionTypes.SET_WHATS_NEW,
    payload: {
      releases,
      latestMajorReleaseId,
      open,
      hasUnseen,
    },
  };
}

export function OPEN_WHATS_NEW() {
  return {
    type: WhatsNewActionTypes.OPEN_WHATS_NEW,
  };
}

export function CLOSE_WHATS_NEW() {
  return {
    type: WhatsNewActionTypes.CLOSE_WHATS_NEW,
  };
}

export function DISMISS_WHATS_NEW() {
  return {
    type: WhatsNewActionTypes.DISMISS_WHATS_NEW,
  };
}

export function MARK_WHATS_NEW_SEEN() {
  return {
    type: WhatsNewActionTypes.MARK_WHATS_NEW_SEEN,
  };
}
